<template>
  <div style="padding-bottom: 4.1rem;">
      <div class="matrix-nav">
        <div 
          v-for="tab in tabs"
          :key="tab.id"
          class="tab" 
          :class="{active: currentTab === tab.id}" 
          @click="currentTab = tab.id">
            <span class="tab-name">{{tab.name}}</span>
          </div>
      </div>
      <transition name="slide-fade">
        <keep-alive>
          <template v-for="tab in tabs">
            <item-list :key="tab.name" v-if="currentTab === tab.id" :type="tab.id"/>
          </template>
        </keep-alive>
      </transition>
  </div>
</template>

<script>
import axios from 'axios'
import ItemList from '../components/ItemList'
export default {
  name: 'App',
  data(){
    return {
      tabs: [{
        id: 2,
        name: '区（市）县'
      },{
        id: 3,
        name: '委办局'
      },{
        id: 4,
        name: '重要机构'
      }],
      currentTab: 2
    }
  },
  created(){
    this.share()
  },
  components: {
    ItemList
  },
  methods: {
    share(){
      axios({
        url: '/cdfb/Index/user/getSignPackageByApi.html'
      }).then(rep => {
        const data = rep.data.data
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名
          jsApiList: ["hideOptionMenu", "updateAppMessageShareData", "updateTimelineShareData","onMenuShareTimeline", "onMenuShareAppMessage"] // 必填，需要使用的JS接口列表
        })

        window.wx.ready(()=>{
          const title = '微矩阵'
          const desc = '成都政务微信矩阵'
          const img  = 'https://images.cdsb.com/Uploads/micropub/20210914/6140681937770.jpg'
          const url = 'https://jumpapp.cdsb.com/cdfb/public/web/matrix.html'

          window.wx.updateAppMessageShareData({ 
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: img, // 分享图标
            success: function () {
              // 设置成功
            }
          })
          window.wx.updateTimelineShareData({ 
            title: title, // 分享标题
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: img, // 分享图标
            success: function () {
              // 设置成功
            }
          })

          window.wx.onMenuShareTimeline({
            title: title, // 分享标题
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: img, // 分享图标
            success: function () {
            // 用户点击了分享后执行的回调函数
            }
          })

          window.wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: img, // 分享图标
            success: function () {
              // 用户点击了分享后执行的回调函数
            }
          })

        })
        
      })
    }
  }
}
</script>

<style>

*{
  padding: 0;
  margin: 0;
  font-family: -apple-system, -apple-system-font, "Microsoft YaHei", Arial, sans-serif;
}
a{
  text-decoration: none;
  color: inherit;
}
#app{
  width: 100vw;
  overflow-x: hidden;
  overflow-y: auto;
}
.matrix-nav{
  padding: 1.4rem 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  font-size: .8rem;
  color: #666666;
  margin-bottom: .5rem;
}
.tab{
  width: 333.3%;
  text-align: center;
}
.active{
  color: #333333;
  font-weight: 600;
}
.tab-name{
  position: relative;
  transform: all .1s;
}
.active .tab-name::after{
  content: "";
  display: block;
  width: 100%;
  padding: 0 .2rem;
  height: .4rem;
  background: linear-gradient(300deg, rgb(0 107 255 / 80%) 0%, rgb(0 65 255 / 80%) 100%);
  border-radius: .21rem;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: -.15rem;
}

.slide-fade-enter-active {
  transition: all .2s ease;
}
/*.slide-fade-leave-active {
  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}*/
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(2rem);
  opacity: 0;
}
</style>
